import styled from "styled-components";
import { DeleteModalStyled } from "../../../../../../components/modal-component/modal-component.styles";

export const RevokeAccessModalBodyStyled = styled(DeleteModalStyled)`
`
